import { useLocation } from "react-router-dom";
import { useMemo } from "react";
import { useSidebarConfig } from "./SidebarConfigContext";
import {
  flattenNavEntries,
  isNavEntryActive,
  isParentActive,
} from "./navActive";

export function useNavActive() {
  const { pathname } = useLocation();
  const config = useSidebarConfig();
  const entries = useMemo(() => flattenNavEntries(config), [config]);

  return {
    isEntryActive: (id: string, href: string) =>
      isNavEntryActive(pathname, id, href, entries),
    isItemActive: (item: NavItem) => {
      if (item.href) {
        return isNavEntryActive(pathname, item.id, item.href, entries);
      }
      return isParentActive(pathname, item, entries);
    },
    isParentActive: (item: NavItem) => isParentActive(pathname, item, entries),
  };
}
